import { AppError } from './app-error.model';
export class BadInputError extends AppError {

}
